// extracted by mini-css-extract-plugin
export var activeFilterButton = "_p1-c";
export var backButton = "_p1-4";
export var backIcon = "_p1-5";
export var chevronShortcut = "_p1-6";
export var container = "_p1-1";
export var editor = "_p1-8";
export var editorWrapper = "_p1-7";
export var prefix = "_p1-2";
export var searchIcon = "_p1-3";
export var suffix = "_p1-9";
export var suffixContent = "_p1-a";
export var suffixText = "_p1-b";
export var wrapper = "_p1-0";